export default {
  throwError(errorObject) {
    const errorMessage = errorObject?.text || errorObject?.message || errorObject;
    const errorStatus = (errorObject.code && parseInt(errorObject.code, 10)) || 0;
    const error = new Error(errorMessage);
    error.status = errorStatus;
    throw error;
  },

  mapApiResponseToError(error) {
    if (error?.response?.data?.error?.text) return new Error(error.response.data.error.text);
    return error;
  },

  getResourceLink(url, query = {}) {
    const queryParams = new URLSearchParams();

    Object.keys(query).forEach((key) => {
      const value = query[key];
      if ([null, undefined].includes(value)) return;

      queryParams.append(key, value);
    });

    const queryString = queryParams.toString();

    return [url, queryString].filter(Boolean).join('?');
  },
};
